import React from 'react';
import PropTypes from 'prop-types';
import PhotoApproval from './PhotoApproval';
import { Typography } from 'kangarootime-ui';

const GridView = ({
  pendingPhotos,
  selectedPhotoIds,
  handlePhotoSelection,
  approvePhotos,
  rejectPhotos,
  viewPhotoInLightbox
}) => (
  <div className='photo-approval-grid'>
    { pendingPhotos.length > 0
      ? pendingPhotos.map(photo => (
        <PhotoApproval
          key={photo.id}
          photo={photo}
          handleSelection={handlePhotoSelection}
          isSelected={selectedPhotoIds.includes(photo.id)}
          approvePhoto={approvePhotos}
          rejectPhoto={rejectPhotos}
          expandPhoto={viewPhotoInLightbox}
        />
      ))
      : <Typography type='subsectionHeader'>No photos require approval</Typography>
    }
  </div>
);

GridView.propTypes = {
  pendingPhotos: PropTypes.array,
  selectedPhotoIds: PropTypes.arrayOf(PropTypes.string),
  handlePhotoSelection: PropTypes.func,
  approvePhotos: PropTypes.func,
  rejectPhotos: PropTypes.func,
  viewPhotoInLightbox: PropTypes.func
};

export default GridView;
